import * as React from 'react';
import type { DataTableColumnHeaderProps } from '../../data-grid.type';
import { ESortDirection, HeaderType } from '../../data-grid.type';
import { tanstackColumnSortedToEnumSort } from '../../util/header';
import { BasicHeader } from '../headers/basic-header';
import { CheckboxHeader } from '../headers/checkbox-header';
import { cn } from '@utils';

export function DataGridColumnHeader<TData, TValue>({
	column,
	table,
	title,
	type = HeaderType.DEFAULT,
	initialSortDirection,
	className,
}: DataTableColumnHeaderProps<TData, TValue>) {
	const isActiveSortColumn = column.getIsSorted() !== false;
	const isChecked = Boolean(
		type === HeaderType.SELECT && (table?.getIsAllPageRowsSelected() || table?.getIsSomePageRowsSelected())
	);
	const isIndeterminate = Boolean(type === HeaderType.SELECT && table?.getIsSomePageRowsSelected());

	const handleOnCheckChanged = () => {
		table?.toggleAllPageRowsSelected();
	};

	const handleOnSortClick = () => {
		const sort = column.getIsSorted();

		column.toggleSorting(sort === ESortDirection.ASC);
	};

	React.useEffect(() => {
		if (initialSortDirection) {
			column.toggleSorting(initialSortDirection !== ESortDirection.ASC);
		}
	}, [column, initialSortDirection]);

	if (!column.getCanSort() && type !== HeaderType.SELECT) {
		return <div className={cn(className)}>{title}</div>;
	}

	return (
		<div data-aid="data-grid-column-header" className={cn('flex items-center space-x-2', className)}>
			{type === HeaderType.SELECT && Boolean(table) ? (
				<CheckboxHeader checked={isChecked} onCheckedChange={handleOnCheckChanged} indeterminate={isIndeterminate} />
			) : (
				<BasicHeader
					className={className}
					isActiveSortColumn={isActiveSortColumn}
					title={title}
					columnSort={tanstackColumnSortedToEnumSort(column.getIsSorted())}
					onClick={handleOnSortClick}
				/>
			)}
		</div>
	);
}
